// ── Form Denúncia — Toggle + Validação + AJAX ─────────────────────────────────

const container = document.querySelector('.form-denuncia');

if (container) {
  initDenunciaToggle(container);
  initIdentificadoToggle(container);
  initDenunciaForm(container);
}

function initDenunciaToggle(container) {
  const ctaWrap = container.querySelector('.form-denuncia__cta-wrap');

  ctaWrap?.addEventListener('click', (e) => {
    if (e.target.closest('.form-denuncia__cta-btn') || e.target.closest('.form-denuncia__cta-icon')) {
      container.classList.add('form-denuncia--open');
      container.querySelector('[name="assunto"]')?.focus();
    }
  });
}

function initIdentificadoToggle(container) {
  const radios    = container.querySelectorAll('[name="identificado"]');
  const idSection = container.querySelector('.form-denuncia__identificacao');
  const nomeInput  = container.querySelector('[name="nome"]');
  const emailInput = container.querySelector('[name="email"]');

  radios.forEach((radio) => {
    radio.addEventListener('change', () => {
      if (radio.value === 'sim') {
        idSection?.classList.add('form-denuncia__identificacao--visible');
        if (nomeInput)  nomeInput.required  = true;
        if (emailInput) emailInput.required = true;
      } else {
        idSection?.classList.remove('form-denuncia__identificacao--visible');
        if (nomeInput)  { nomeInput.required  = false; nomeInput.value  = ''; }
        if (emailInput) { emailInput.required = false; emailInput.value = ''; }
      }
    });
  });
}

function initDenunciaForm(container) {
  const form = container.querySelector('.form-denuncia__form');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    clearDenunciaErrors(form);

    const errors = validateDenunciaForm(form);
    if (errors.length > 0) {
      errors.forEach(({ field, message }) => showDenunciaFieldError(field, message));
      errors[0].field.focus();
      return;
    }

    const btnText  = form.querySelector('.form-denuncia__btn-text');
    const btnArrow = form.querySelector('.form-denuncia__btn-arrow');
    const originalText = btnText ? btnText.textContent : '';

    if (btnText)  { btnText.disabled  = true; btnText.textContent = 'Enviando...'; }
    if (btnArrow) { btnArrow.disabled = true; }

    if (!window.rbDenunciaAjax?.url) {
      showDenunciaFeedback(form, 'Configuração de envio indisponível.', 'error');
      if (btnText)  { btnText.disabled  = false; btnText.textContent = originalText; }
      if (btnArrow) { btnArrow.disabled = false; }
      return;
    }

    const data = new FormData(form);
    data.set('action', 'rb_denuncia_form_submit');

    try {
      const response = await fetch(window.rbDenunciaAjax.url, {
        method: 'POST',
        body: data,
      });

      if (!response.ok) throw new Error('network');

      const json = await response.json();

      if (json.success) {
        showDenunciaFeedback(form, json.data?.message || 'Denúncia enviada com sucesso. Obrigado pelo seu compromisso.', 'success');
        form.reset();
        const idSection  = container.querySelector('.form-denuncia__identificacao');
        const nomeInput  = form.querySelector('[name="nome"]');
        const emailInput = form.querySelector('[name="email"]');
        idSection?.classList.remove('form-denuncia__identificacao--visible');
        if (nomeInput)  nomeInput.required  = false;
        if (emailInput) emailInput.required = false;
      } else {
        const msg = json.data?.message || 'Ocorreu um erro. Tente novamente.';
        showDenunciaFeedback(form, msg, 'error');
      }
    } catch (err) {
      console.error('Denuncia form error:', err);
      showDenunciaFeedback(form, 'Ocorreu um erro de conexão. Tente novamente.', 'error');
    } finally {
      if (btnText)  { btnText.disabled  = false; btnText.textContent = originalText; }
      if (btnArrow) { btnArrow.disabled = false; }
    }
  });
}

function validateDenunciaForm(form) {
  const errors     = [];
  const emailRe    = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const identificado = form.querySelector('[name="identificado"]:checked')?.value ?? '';

  const rules = [
    { name: 'assunto',  type: 'select', message: 'Por favor, selecione uma opção.' },
    { name: 'mensagem', type: 'text',   message: 'Por favor, descreva a denúncia.' },
  ];

  const radioChecked = form.querySelector('[name="identificado"]:checked');
  if (!radioChecked) {
    const firstRadio = form.querySelector('[name="identificado"]');
    if (firstRadio) errors.push({ field: firstRadio, message: 'Por favor, selecione uma opção.' });
  }

  if (identificado === 'sim') {
    rules.push({ name: 'nome',  type: 'text',  message: 'Por favor, preencha seu nome.' });
    rules.push({ name: 'email', type: 'email', message: 'Informe um endereço de email válido.' });
  }

  rules.forEach(({ name, type, message }) => {
    const field = form.querySelector(`[name="${name}"]`);
    if (!field) return;

    let invalid = false;
    if (type === 'text')   invalid = field.value.trim() === '';
    if (type === 'select') invalid = field.value === '';
    if (type === 'email')  invalid = !emailRe.test(field.value.trim());

    if (invalid) errors.push({ field, message });
  });

  return errors;
}

function showDenunciaFieldError(field, message) {
  const wrapper = field.closest('.form-denuncia__field') || field.closest('fieldset');
  if (!wrapper) return;
  wrapper.classList.add('form-denuncia__field--error');
  const span = document.createElement('span');
  span.className = 'form-denuncia__error-msg';
  span.textContent = message;
  wrapper.appendChild(span);
}

function clearDenunciaErrors(form) {
  form.querySelectorAll('.form-denuncia__field--error').forEach((el) => {
    el.classList.remove('form-denuncia__field--error');
  });
  form.querySelectorAll('.form-denuncia__error-msg').forEach((el) => el.remove());

  const feedback = form.querySelector('.form-denuncia__feedback');
  if (feedback) {
    feedback.className = 'form-denuncia__feedback';
    feedback.textContent = '';
  }
}

function showDenunciaFeedback(form, message, type) {
  const feedback = form.querySelector('.form-denuncia__feedback');
  if (!feedback) return;
  feedback.className = `form-denuncia__feedback form-denuncia__feedback--${type}`;
  feedback.textContent = message;
  feedback.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
}
